import { authorizedRequest } from '../../common/request';
import { uploadActionTypes } from './upload-action-types';

export const requestUpload = (dispatch, file, ccId) => {
	const uploadRequestUri = `${process.env.REACT_APP_WEB_API_URI}/sec/v1/uploadrequest`;
	const requestMetadata = {
		title: encodeURI(file.name),
		fileName: encodeURI(file.name),
		fileSize: file.size,
		ccId: ccId
	};

	authorizedRequest(uploadRequestUri, requestMetadata, 'POST')
		.then(postData => {
			const uri = postData.uploadUrl;
			const uuid = postData.uuid;

			dispatch(requestUploadUrlSuccess(dispatch, uri, uuid));
			uploadFile(dispatch, file, uri)
				.then((uploadedFile, request) => {
					uploadedFile.success = true;
					uploadedFile.inProgress = false;
					dispatch(uploadFileSuccess(uploadedFile));
					request = null;
				})
				.catch((error, request) => {
					file.failure = true;
					file.success = false;
					file.inProgress = false;
					dispatch(uploadFileFailure(file, error));
					request = null;
				});

			return {
				type: uploadActionTypes.UPLOAD_FILE_STARTED,
				file: file
			};

			//dispatch(enqueueFileToUpload(file, uri));
		})
		.catch(error => dispatch(requestUploadUrlFailure(error)));

	return {
		type: uploadActionTypes.UPLOAD_FILE_REQUEST,
		name: file.name,
		file: file
	};
};

export const clearUploadItems = () => {
	return {
		type: uploadActionTypes.UPLOAD_CLEAR_ITEMS
	};
};

export const currentUploadsComplete = albumId => {
	return {
		type: uploadActionTypes.UPLOAD_CURRENT_COMPLETE,
		albumId: albumId
	};
};

export const setCurrentUploadAlbum = (albumId, albumName) => {
	return {
		type: uploadActionTypes.UPLOAD_SET_CURRENT_ALBUM,
		albumId: albumId,
		albumName: albumName
	};
};

export const removeFileFromQueue = file => {
	return {
		type: uploadActionTypes.UPLOAD_DEQUEUE_ITEM,
		file: file
	};
};

export const addThumbAsProcessed = thumb => {
	return {
		type: uploadActionTypes.UPLOAD_THUMB_PROCESSED,
		thumb
	};
};

export const toggleIsCancelDownloadDialogOpen = () => {
	return {
		type: uploadActionTypes.UPLOAD_CANCEL_DIALOG_TOGGLE,
		
	};
};

export const uploadsComplete = () => {
	return {
		type: uploadActionTypes.UPLOAD_UPLOADS_COMPLETE,
		
	};
};

export const uploadsInProgress = () => {
	return {
		type: uploadActionTypes.UPLOAD_UPLOADS_INPROGRESS,
		
	};
};





export const enqueueFileToUpload = file => {
	return {
		type: uploadActionTypes.UPLOAD_ENQUEUE_ITEM,
		file: file
	};
};

const requestUploadUrlFailure = error => {
	return {
		type: uploadActionTypes.UPLOAD_POST_URL_FAILURE,
		error: error
	};
};

const requestUploadUrlSuccess = (dispatch, uri, uuid) => {
	return {
		type: uploadActionTypes.UPLOAD_POST_URL_SUCCESS,
		uri: uri,
		uuid: uuid
	};
};

const uploadFileSuccess = file => {
	return {
		type: uploadActionTypes.UPLOAD_FILE_SUCCESS,
		file: file,
		name: file.name
	};
};

const uploadFileFailure = (file, error) => {
	file.failure = true;
	return {
		type: uploadActionTypes.UPLOAD_FILE_FAILURE,
		file: file,
		name: file.name,
		error: error
	};
};

const uploadFileProgress = (file, total, loaded) => {
	return {
		type: uploadActionTypes.UPLOAD_FILE_PROGRESS,
		file: file,
		name: file.name,
		total: total ? total : file.size,
		loaded: loaded,
		progress: loaded / total * 100
	};
};

const uploadFileComplete = completeFile => {
	return {
		type: uploadActionTypes.UPLOAD_FILE_COMPLETE,
		file: completeFile
	};
};

const uploadFileStarted = (file, total) => {
	return {
		type: uploadActionTypes.UPLOAD_FILE_STARTED,
		file: file,
		name: file.name,
		total: total,
		progress: 0
	};
};

const uploadFile = async (dispatch, file, location) => {
	return new Promise((resolve, reject) => {
		let request = new XMLHttpRequest();
		file.request = request;

		let fr = new FileReader();
		fr.onload = () => {
			request.send(file);
		};
		fr.readAsArrayBuffer(file);
		request.open('PUT', location, true);

		request.setRequestHeader('Content-Type', file.type);
		request.setRequestHeader('Content-Disposition', `attachment; filename="${encodeURI(file.name)}"`);
		request.setRequestHeader('X-File-Size', file.size);
		request.setRequestHeader('X-File-Name', encodeURI(file.name));
		request.setRequestHeader('X-File-Type', file.type);

		request.onabort = () => {

		};

		request.onerror = error => {
			reject(file, error);
		};

		request.onloadstart = progressEvent => {
			dispatch(uploadFileStarted(file, progressEvent.total));
		};
		request.upload.onprogress = progressEvent => {
			if (!file.inProgress) {
				file.inProgress = true;
			}

			request.lastUpdate = Date.now();
			dispatch(uploadFileProgress(file, progressEvent.total, progressEvent.loaded));
			if(progressEvent.total > 0.99999){
                dispatch(uploadFileComplete(file, progressEvent.total, progressEvent.loaded));
			}
		};

		request.onreadystatechange = () => {
			if (request.readyState === XMLHttpRequest.DONE && request.status === 200) {
				resolve(file, request);
			} else if (request.readyState === XMLHttpRequest.DONE && request.status !== 200) {
				reject(request.statusText, request);
			} else {
				// console.log('ready state', request.readyState);
			}
		};
	});
};

export const pauseUpload = () => {
	return {
		type: uploadActionTypes.UPLOAD_PAUSE
	};
};

export const stopUpload = () => {
	return {
		type: uploadActionTypes.UPLOAD_STOP
	};
};

export const restartUpload = () => {
	return {
		type: uploadActionTypes.UPLOAD_RESTART
	};
};

export const continueUpload = () => {
	return {
		type: uploadActionTypes.UPLOAD_CONTINUE
	};
};



// WEBPACK FOOTER //
// ./src/upload/actions/upload-actions.js